export const accolades = [
  {
    image: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/BEST_award.png',
    title: '1st Place, Venture Course',
    href: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/image_heritude.jpeg',
    description: 'Entrepreneurship & Technology Ventures, Schulich. Built MVP and three pitch decks.',
  },
  {
    image: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/LSO_award.png',
    title: 'Life Sciences Ontario Scholarship',
    href: 'https://lifesciencesontario.ca/2019-scholarship-winners/',
    description: 'For academic achievement. Sponsored by Mississauga Board of Trade.',
  },
  {
    image: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/LinkedIn_Learning.png',
    title: 'LinkedIn Learning Champions',
    href: 'https://www.linkedin.com/feed/update/urn:li:activity:6671069468921208832/',
    description: 'Completed the Champions program, mentored by Jennifer Catello.',
  },
];
